<template>
  <div class="pcm-wrapper" id="pcm-wrapper">
    <div class="logo"></div>
    <div class="contactBox">
      <div class="telegram" v-if="cTg" @click="jumpUrl(cTg)"></div>
      <div class="potato" v-if="cPotato" @click="jumpUrl(cPotato)"></div>
      <div class="business" v-if="cBusiness" @click="jumpUrl(cBusiness)"></div>
      <div class="channel" v-if="cChannel" @click="jumpUrl(cChannel)"></div>
    </div>
    <div class="figureBox"></div>
    <div class="logoText"></div>
    <div class="downloadBox">
      <div class="qrcodeBox">
        <img class="qrcode" :src="qrImg" alt="" />
        <div class="mobileTip"></div>
      </div>
      <div class="ucTip"></div>
    </div>
  </div>
</template>

<script>
import autofit from "autofit.js";
autofit.init();
export default {
  props: ["qrImg"],
  data() {
    return {
      cTg: "",
      cPotato: "",
      cBusiness: "",
      cChannel: "",
    };
  },
  mounted() {
    autofit.init(
      {
        dh: 1080,
        dw: 1920,
        el: "#pcm-wrapper",
        resize: true,
      },
      false
    ); // 可关闭控制台运行提示输出
  },
  methods: {
    setConfigs(configs) {
      configs.forEach((item) => {
        if (item.configType === "tg_group") {
          this.cTg = item.link;
        } else if (item.configType === "potato_group") {
          this.cPotato = item.link;
        } else if (item.configType === "sw_cooperate") {
          this.cBusiness = item.link;
        } else if (item.configType === "qd_cooperate") {
          this.cChannel = item.link;
        }
      });
    },
    jumpUrl(url) {
      window.open(url);
    },
  },
};
</script>

<style lang="scss" scoped>
.pcm-wrapper {
  width: 100vw;
  height: 100vh;
  background: url("./../../../assets/images/pc/bg1.webp") no-repeat;
  background-size: 100% 100%;
  .logo {
    width: 325px;
    height: 102px;
    background: url("./../../../assets/images/pc/logo.png") no-repeat;
    background-size: 100% 100%;
    position: absolute;
    top: 25px;
    left: 131px;
  }
  .contactBox {
    position: fixed;
    right: 80px;
    top: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 999;
    .telegram {
      height: 60px;
      width: 60px;
      background: url("./../../../assets/images/pc/telegram.png") no-repeat;
      background-size: 100% 100%;
      margin-right: 40px;
      cursor: pointer;
    }
    .potato {
      height: 68px;
      width: 68px;
      background: url("./../../../assets/images/pc/potato.png") no-repeat;
      background-size: 100% 100%;
      margin-right: 40px;
      cursor: pointer;
    }
    .business {
      height: 68px;
      width: 68px;
      background: url("./../../../assets/images/pc/business.png") no-repeat;
      background-size: 100% 100%;
      margin-right: 40px;
      cursor: pointer;
    }
    .channel {
      height: 68px;
      width: 68px;
      background: url("./../../../assets/images/pc/channel.png") no-repeat;
      background-size: 100% 100%;
      cursor: pointer;
    }
  }
  .figureBox {
    width: 733px;
    height: 789.913px;
    position: absolute;
    right: 227px;
    top: 153px;
    background: url("../../../assets/images/pc/figure1.webp") no-repeat;
    background-size: 100% 100%;
  }
  .logoText {
    width: 755px;
    height: 597px;
    position: absolute;
    left: 205px;
    top: 203px;
    background: url("../../../assets/images/pc/logoText1.webp") no-repeat;
    background-size: 100% 100%;
  }
  .downloadBox {
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: absolute;
    left: 282px;
    bottom: 98px;
    .qrcodeBox {
      margin-right: 26px;
      display: flex;
      align-items: center;
      .qrcode {
        width: 181.598px;
        height: 181.598px;
        border: 2.906px solid #b1e3ff;
        background: #fff;
      }
      .mobileTip {
        width: 39.225px;
        height: 181.598px;
        background: url("./../../../assets/images/pc/mobileTip.webp") no-repeat;
        background-size: 100% 100%;
      }
    }
    .ucTip {
      height: 158px;
      width: 353px;
      background: url("./../../../assets/images/pc/ucTip.webp") no-repeat;
      background-size: 100% 100%;
    }
  }
}
</style>
